<template>
  <el-dialog :title="mytitle" :visible.sync="dialogFormVisible" custom-class="list-dialog" center :append-to-body="true"
             :close-on-click-modal="false"
  >
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-input style="width:200px;"
                  placeholder="请输入内容"
                  prefix-icon="el-icon-search"
                  v-model="searchdata">
        </el-input>
        <el-select v-model="servedserial" v-if="idd.length>1 && couponServedserial==''&&!filterbyservedserial" placeholder="服务部门"
                   style="width:150px">
          <el-option
            v-for="item in idd"
            :key="item.serialnum"
            :label="item.dname"
            :value="item.serialnum">
          </el-option>
        </el-select>
        <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid">搜索</el-button>
      </el-col>
    </div>

    <el-table
      :data="tableData"
      :height="tableHeight(151)"
      size="mini"
      stripe
      border
      style="width: 100%;"
    >
      <el-table-column type="index" width="60" label="序号" align="center">
      </el-table-column>
      <el-table-column
        prop="customerserial"
        label="编码"
        align="left"
        header-align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="deptname"
        label="名称"
        align="left"
        header-align="center"
      >
      </el-table-column>
      <el-table-column prop="unitgroup" label="分类" align="left" header-align="center" width="200">
      </el-table-column>
      <el-table-column
        label="区域"
        align="left"
        header-align="center"
      >
        <template slot-scope="scope">
          {{scope.row.province}}{{scope.row.city}}{{scope.row.county}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="90">
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="handleSelect(scope.$index, scope.row)">选择
          </el-button>

        </template>
      </el-table-column>
    </el-table>

    <div class="foot" :style="{textAlign:'center' }">
      <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
    </div>
    <!--<div slot="footer" class="dialog-footer">-->
    <!--<el-button @click="dialogFormVisible = false">取 消</el-button>-->
    <!--</div>-->
  </el-dialog>


</template>

<script>
  //  import ExternaldeptEdit from './externaldeptEdit';
  import {getListData, deleteData} from '@/api/set/externaldept';
  import {independentDept} from '@/api/set/dept';

  export default {
    name: 'ExternaldeptSel',
    data() {
      return {
        activeIndex: '1',
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        searchdata: "",
        myunitgroup: this.unitgroup,
        mytitle: this.title,
        loading: true,
        servedserial: "",
        idd: [],
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableData: [],
        coupon: '',
        province: '',//省
        city: '',//市
        county: '',//县
        couponServedserial: '',//独立核算
      }
    },
    props: {
      unitgroup: {
        default: 1
      },
      title: {
        default: "客户信息"
      },
      parentcustomerserial:{//上级客户编码
        default:""
      },
      filterbyservedserial:{//根据当前登录人所属的加工中心过滤数据
        default:false
      },
      settingmenthod:{//200表示月结的客户
        default:""
      },
      storeInfo:{
        default:""
      }
    },
    // props: ["storeInfo"],//赠送优惠券传参（地区、核算部门）
    methods: {
      handleSelect(index, row) {
        this.$emit("select", row.customerserial, row.deptname, row)
        this.dialogFormVisible = false
      },

      bindGrid() {
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          search: this.searchdata.trim(),
          unitgroup: this.myunitgroup,
          servedserial: this.servedserial,
          parentcustomerserial:this.parentcustomerserial,
          coupon: this.coupon,
          province: this.province,//省
          city: this.city,//市
          county: this.county,//县
          couponServedserial: this.couponServedserial,//独立核算
          settingmenthod:this.settingmenthod
        }).then(response => {
          this.tableData = response.data.obj.rows
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        });
      },
      add() {
        this.$refs.DataContactEdit.initForm()
        this.OpenDialog()
      },
      OpenDialog() {
        this.$refs.DataContactEdit.show()
      },
      show(unitgroup, title) {
        this.coupon = ''
        this.province = ''//省
        this.city = ''//市
        this.county = ''//县
        this.couponServedserial = ''//独立核算
        if (unitgroup) {
          this.myunitgroup = unitgroup
        }
        if (title) {
          this.mytitle = title
        }
        // if (unitgroup || title) {
        //   this.bindGrid()
        // }
        this.dialogFormVisible = true
        if (this.storeInfo) {
          this.coupon = this.storeInfo.coupon
          this.province = this.storeInfo.province//省
          this.city = this.storeInfo.city//市
          this.county = this.storeInfo.county//县
          this.couponServedserial = this.storeInfo.independentserial//独立核算
        }
        this.bindGrid()
      },

    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.servedserial = this.userInfoModel.independentserial;
      //默认值
      if (!this.userInfoModel.independentserial) {
        independentDept().then(response => {
          this.idd = response.data.obj
          if (this.userInfoModel.independentserial == "") {
            this.idd.unshift({serialnum: "all", dname: "全部"})
            this.servedserial = 'all';
          }
          this.bindGrid()
        })
      } else
        this.bindGrid()
    },
    components: {
     // ExternaldeptEdit,
    }

  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/set/externaldept/ExternaldeptSel.vue